import React from "react";
// import * as _ from "lodash"

import {
  withTheme,
  AppBar,
  Toolbar,
  IconButton,
  List,
  ListItem,
  Divider,
  ListItemText,
  CircularProgress,
  Button,
  Typography,
  Dialog,
  Paper,
} from "@material-ui/core";
import { Close, LocationOn } from "@material-ui/icons";

import s from "./order.module.css";

import GlobalContext from "../../context/globalContext";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { isAndroid } from "react-device-detect";

class Order extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      newCartCreatedDialog: false,
      cancellationProgress: false,
      cancelOrderVerifyDialogOpen: false,
    };
  }

  closeOrderScreen = async () => {
    if (this.context.global.data.newCartCreated) {
      // this.setState({ newCartCreatedDialog: true });
      // setTimeout(() => {
      // this.setState({ newCartCreatedDialog: false })
      // this.context.global.getUserFavorites()
      // this.props.history.goBack();
      // }, 2000);
      this.context.global.setGlobalState("newCartCreated", false);
      this.props.history.replace("/find-hot-spot");
    } else {
      // this.context.global.getUserFavorites()
      this.props.history.goBack();
    }
  };

  componentWillMount() {
    if (this.context.global.data.newCartCreated) {
      this.props.history.push(this.props.history.location.pathname);
    }
    window.scrollTo(0, 0);
    this.context.global.getUserOrders();
  }

  componentDidMount() {
    window.onpopstate = this.onBackOrForwardButtonEvent;
  }

  onBackOrForwardButtonEvent = (e) => {
    e.preventDefault();
    this.closeOrderScreen();
  };

  componentWillUnmount() {
    window.onpopstate = null;
  }

  openCancelOrderDialog = () => {
    this.setState({ cancelOrderVerifyDialogOpen: true });
  };

  closeCancelOrderDialog = () => {
    this.setState({ cancelOrderVerifyDialogOpen: false });
  };

  confirmCancelOrder = async () => {
    let { orderUuid } = this.props.match.params;
    let order = this.context.global.data.orders.find(
      (x) => x.uuid === orderUuid
    );
    if (!order || this.pastBufferCheck(order.popUpLocationInstance)) {
      this.context.global.openErrorSnackbar(
        "Orders must be cancelled before shopping window has ended."
      );
      return;
    }
    this.setState({ cancellationProgress: true });
    try {
      await this.context.global.cancelOrder(orderUuid);
    } catch (error) {
      this.setState({
        cancelOrderVerifyDialogOpen: false,
        cancellationProgress: false,
      });
      this.props.history.goBack();
      return;
    }
    this.context.global.openSuccessSnackbar("Order Cancelled.");
    this.props.history.replace(`/dashboard`);
  };

  async modifyOrder() {
    let { orderUuid } = this.props.match.params;
    this.props.history.push(`/orders/${orderUuid}/modify`);
  }

  pastBufferCheck(puli) {
    let timeCheck = moment(puli.pickupTimestampStart * 1000);

    return moment().isAfter(
      moment(timeCheck).subtract(puli.bufferTime, "second")
    );
  }

  render() {
    let { orderUuid } = this.props.match.params;
    let { orders } = this.context.global.data;
    let { theme } = this.props;
    let { newCartCreatedDialog, cancelOrderVerifyDialogOpen } = this.state;

    let order;
    let googleEscapedAddress;

    const moneyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (orders) {
      order = orders.find((x) => x.uuid === orderUuid);
      let address = order.popUpLocationInstance.popUpLocation.address1
        .concat(" ", order.popUpLocationInstance.popUpLocation.city)
        .concat(" ", order.popUpLocationInstance.popUpLocation.state)
        .concat(" ", order.popUpLocationInstance.popUpLocation.zip);
      googleEscapedAddress = address.replace(/ /g, "+");
    } else {
      this.context.global.getUserOrders();
      return <div />;
    }

    let cardTotal = null;
    if (order.chargeInformation) {
      let ccInfo = JSON.parse(order.chargeInformation);
      cardTotal = ((ccInfo.amount - ccInfo.amount_refunded) / 100).toFixed(2);
    }

    let calcAdjustment = 0;
    for (let item of order.calculatedInventoryItems) {
      if (!item.packed) {
        calcAdjustment =
          calcAdjustment +
          parseInt(item.orderedQuantity) * parseInt(item.basePrice);
      } else if (item.packed && item.substituted) {
        calcAdjustment =
          calcAdjustment +
          parseInt(item.orderedQuantity) * parseInt(item.subBasePrice);
        calcAdjustment =
          calcAdjustment -
          parseInt(item.quantityInCart) * parseInt(item.basePrice);
      } else if (item.packed && !item.substituted) {
        calcAdjustment =
          calcAdjustment +
          (parseInt(item.orderedQuantity) - parseInt(item.quantityInCart)) *
            parseInt(item.basePrice);
      }
    }
    let calcSubTotal = order.originalTotal - calcAdjustment;


    let deliveryFee = order.deliveryFee ? moneyFormatter.format(order.deliveryFee / 100) : 0
    let serviceFee = order.serviceFee ? moneyFormatter.format(order.serviceFee / 100) : 0

    return (
      <>
        <AppBar className={s.orderAppBar}>
          <Toolbar className={s.orderToolbar}>
            <div className={s.orderTitleTotal}>
              $
              {cardTotal
                ? cardTotal
                : order.applyCredit &&
                  order.creditUsed > 0 &&
                  order.adjustment > 0 &&
                  order.total - order.adjustment < 0
                ? (0 + order.tipAmount / 100).toFixed(2)
                : (
                    (order.total - order.adjustment) / 100 +
                    order.tipAmount / 100
                  ).toFixed(2)}
            </div>
            {/* <div className={s.orderTitle}>Order {order.orderNumber}</div> */}
            <div className={s.closeButtonContainer}>
              <IconButton
                color="inherit"
                onClick={() => this.closeOrderScreen()}
                aria-label="Close"
                className={s.orderAppBar_Icon}
              >
                <Close />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        {newCartCreatedDialog ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              height: 200,
              textAlign: "center",
              marginTop: "80px",
              padding: "2rem 0 2rem 0",
            }}
          >
            <CircularProgress />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className={s.newShoppingCartText}>A new shopping cart </div>
              <div className={s.newShoppingCartText}>is being created </div>
              <div className={s.newShoppingCartText}>for this HotSpot</div>
            </div>
          </div>
        ) : (
          <>
            <div style={{ marginTop: "65px" }} />
            <div className={s.hotspotList}>
              <div style={{}}>
                {order.fullfilledTimestamp ||
                moment().subtract(30, "m").format("X").valueOf() >
                  order.popUpLocationInstance.pickupTimestampEnd ? null : (
                  <div
                    className={s.orderAddress}
                    style={{
                      background: `url(${order.popUpLocationInstance.popUpLocation.imageUrl})`,
                      content: "",
                      opacity: 0.2,
                    }}
                  />
                )}

                <div
                  className={s.calloutName}
                  style={{ padding: "5px", minHeight: "150px" }}
                >
                  {order.popUpLocationInstance.fulfillmentType ===
                  "DELIVERY" ? (
                    <>
                      <div className={s.calloutHeader}>
                        {order.deliveryLocation.address1}
                      </div>
                      <div className={s.calloutSubheader}>
                        {order.deliveryLocation.address2}
                        <br />
                        {order.deliveryLocation.city}{" "}
                        {order.deliveryLocation.state}{" "}
                        {order.deliveryLocation.zip}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={s.calloutHeader}>
                        {order.popUpLocationInstance.popUpLocation.name}
                      </div>
                      <div className={s.calloutSubheader}>
                        {order.popUpLocationInstance.popUpLocation.address1}
                        <br />
                        {order.popUpLocationInstance.popUpLocation.city}{" "}
                        {order.popUpLocationInstance.popUpLocation.state}{" "}
                        {order.popUpLocationInstance.popUpLocation.zip}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {order.cancelled ? (
                <div
                  style={{
                    color: "red",
                    fontVariant: "small-caps",
                    fontWeight: "bold",
                    fontSize: 15,
                  }}
                >
                  cancelled
                </div>
              ) : (
                <div
                  style={{
                    color: theme.palette.primary.dark,
                    fontVariant: "small-caps",
                    fontWeight: "bold",
                    fontSize: 15,
                  }}
                >
                  order placed!
                </div>
              )}
              {order.fullfilledTimestamp ||
              moment().subtract(30, "m").format("X").valueOf() >
                order.popUpLocationInstance.pickupTimestampEnd ? (
                <>
                  {order.fullfilledTimestamp && !order.cancelled ? (
                    <>
                      <Typography
                        variant="h6"
                        style={{
                          color: theme.palette.primary.main,
                          padding: "30px 20px 0 20px",
                          textAlign: "center",
                        }}
                      >
                        Order Fulfilled
                      </Typography>
                      <Typography
                        variant="h6"
                        style={{
                          color: theme.palette.primary.main,
                          padding: "0px 20px 30px 20px",
                          textAlign: "center",
                        }}
                      >
                        {moment().format("LLLL")}
                      </Typography>
                    </>
                  ) : (
                    <Typography
                      variant="h6"
                      style={{
                        color: "#870b00",
                        padding: "30px 20px",
                        textAlign: "center",
                      }}
                    >
                      Order Not Picked Up
                    </Typography>
                  )}
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      paddingRight: "10px",
                    }}
                  >
                    {!isAndroid && order.fulfillmentType === "PICKUP" ? (
                      <Link
                        target="_blank"
                        to={`//www.google.com/maps/search/?api=1&query=${googleEscapedAddress}`}
                        style={{
                          color: "#555",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <LocationOn />
                        <div style={{ top: "-50" }}>Map</div>
                      </Link>
                    ) : null}
                  </div>
                  {order.popUpLocationInstance.specialInstructions ? (
                    <>
                      <Typography variant="h6" className={s.listItemText}>
                        Special Instructions
                      </Typography>
                      <Typography variant="body1" className={s.listItemText}>
                        {order.popUpLocationInstance.specialInstructions}
                      </Typography>
                    </>
                  ) : null}

                  {/* <Button style={{ maxWidth: 300, alignSelf: 'center', marginTop: '20px' }}>
                    <Link
                      target="_blank"
                      to={`//www.google.com/maps/search/?api=1&query=${googleEscapedAddress}`}
                      style={{ textDecoration: 'none', width: '100%' }}
                    >
                      <Typography variant="body1" style={{ color: 'white' }}>
                        Open Location Google Maps
                      </Typography>
                    </Link>
                  </Button> */}
                  <div className={s.qrCodeContainer}>
                    <img src={order.qrCode} alt={""} />
                  </div>
                </>
              )}
              <Divider />
              <List className={s.shoppingCartListContainer}>
                {order.calculatedInventoryItems.map((item) => {
                  if (item.numberInCart === 0) {
                    return <></>;
                  }

                  return (
                    <OrderItem
                      key={item.uuid}
                      item={item}
                      theme={theme}
                      orderPaid={order.isPaid}
                    />
                  );
                })}
              </List>
              <List>
                {order.isPaid ? (
                  <>
                    <ListItem className={s.taxContainer}>
                      <div className={s.tax}>
                        <div className={s.label}>TAX</div>
                        <div className={s.value}>
                          ${(order.salesTax / 100).toFixed(2)}
                        </div>
                      </div>
                    </ListItem>
                    {order.applyCredit ? (
                      <>
                        <ListItem className={s.totalContainer}>
                          <div className={s.total}>
                            <div className={s.label}>SUBTOTAL</div>
                            <div className={s.value}>
                              ${(calcSubTotal / 100).toFixed(2)}
                            </div>
                          </div>
                        </ListItem>
                        <ListItem className={s.totalContainer}>
                          <div className={s.total}>
                            <div className={s.label}>CREDIT</div>
                            <div className={s.value}>
                              -${(order.creditUsed / 100).toFixed(2)}
                            </div>
                          </div>
                        </ListItem>
                      </>
                    ) : null}
                    {deliveryFee == null ? null : (
                      <ListItem className={s.taxContainer}>
                        <div className={s.tax}>
                          <div className={s.label}>DELIVERY FEE</div>
                          <div className={s.value}>
                            {deliveryFee}
                          </div>
                        </div>
                      </ListItem>
                    )}
                    {serviceFee == null ? null : (
                      <ListItem className={s.taxContainer}>
                        <div className={s.tax}>
                          <div className={s.label}>SERVICE FEE</div>
                          <div className={s.value}>
                            {serviceFee}
                          </div>
                        </div>
                      </ListItem>
                    )}
                    <ListItem className={s.totalContainer}>
                      <div className={s.tax}>
                        <div className={s.label}>Optional Service Charge</div>
                        <div className={s.value}>
                          ${(order.tipAmount / 100).toFixed(2)}
                        </div>
                      </div>
                    </ListItem>
                    <ListItem className={s.totalContainer}>
                      <div className={s.total}>
                        <div className={s.label}>
                          TOTAL CHARGED (AFTER ADJUSTMENTS)
                        </div>
                        <div className={s.totalValue}>
                          $
                          {cardTotal
                            ? cardTotal
                            : order.applyCredit &&
                              order.creditUsed > 0 &&
                              order.adjustment > 0 &&
                              order.total - order.adjustment < 0
                            ? (0 + order.tipAmount / 100).toFixed(2)
                            : (
                                (order.total - order.adjustment) / 100 +
                                order.tipAmount / 100
                              ).toFixed(2)}
                        </div>
                      </div>
                    </ListItem>
                  </>
                ) : (
                  <>
                    <ListItem className={s.taxContainer}>
                      <div className={s.tax}>
                        <div className={s.label}>TAX</div>
                        <div className={s.value}>
                          ${(order.salesTax / 100).toFixed(2)}
                        </div>
                      </div>
                    </ListItem>
                    {order.applyCredit ? (
                      <>
                        <ListItem className={s.totalContainer}>
                          <div className={s.total}>
                            <div className={s.label}>SUBTOTAL</div>
                            <div className={s.value}>
                              ${(order.originalTotal / 100).toFixed(2)}
                            </div>
                          </div>
                        </ListItem>
                        <ListItem className={s.totalContainer}>
                          <div className={s.total}>
                            <div className={s.label}>CREDIT</div>
                            <div className={s.value}>
                              -${(order.creditUsed / 100).toFixed(2)}
                            </div>
                          </div>
                        </ListItem>
                      </>
                    ) : null}
                    {deliveryFee == null ? null : (
                      <ListItem className={s.taxContainer}>
                        <div className={s.tax}>
                          <div className={s.label}>DELIVERY FEE</div>
                          <div className={s.value}>
                            {deliveryFee}
                          </div>
                        </div>
                      </ListItem>
                    )}
                    
                    {serviceFee == null ? null : (
                      <ListItem className={s.taxContainer}>
                        <div className={s.tax}>
                          <div className={s.label}>SERVICE FEE</div>
                          <div className={s.value}>
                            {serviceFee}
                          </div>
                        </div>
                      </ListItem>
                    )}
                    <ListItem className={s.totalContainer}>
                      <div className={s.tax}>
                        <div className={s.label}>Optional Service Charge</div>
                        <div className={s.value}>
                          ${(order.tipAmount / 100).toFixed(2)}
                        </div>
                      </div>
                    </ListItem>
                    <ListItem className={s.totalContainer}>
                      <div className={s.total}>
                        <div className={s.label}>TOTAL</div>
                        <div className={s.totalValue}>
                          ${(order.total / 100).toFixed(2)}
                        </div>
                      </div>
                    </ListItem>
                  </>
                )}
              </List>
            </div>
            {/* {order.isPaid ||
            this.pastBufferCheck(order.popUpLocationInstance) ? null : (
              <div style={{ margin: "2rem", display: "flex", flex: 1 }}>
                <Button
                  onClick={() => {
                    this.modifyOrder();
                  }}
                  style={{ flex: 1 }}
                >
                  Modify Order
                </Button>
              </div>
            )} */}
            <div style={{ margin: "2rem", display: "flex", flex: 1 }}>
              <Button
                onClick={() => {
                  this.props.history.replace(
                    `/feedback?orderUuid=${orderUuid}`
                  );
                }}
                style={{ flex: 1 }}
              >
                Problem with your order?
              </Button>
            </div>
            {order.isPaid ||
            this.pastBufferCheck(order.popUpLocationInstance) ? null : (
              <div
                style={{
                  margin: "2rem",
                  display: order.cancelled ? "none" : "flex",
                  flex: 1,
                }}
              >
                <Button
                  onClick={this.openCancelOrderDialog}
                  style={{ flex: 1, background: "red" }}
                >
                  Cancel Order
                </Button>
              </div>
            )}
          </>
        )}

        <Dialog
          open={cancelOrderVerifyDialogOpen}
          onClose={this.closeCancelOrderDialog}
        >
          <div style={{ height: 200, width: 200, margin: 20, padding: 20 }}>
            <div className={s.panel_title}>
              <Typography
                style={{
                  fontVariant: "small-caps",
                  fontSize: 18,
                  color: "#555",
                }}
                align={"left"}
              >
                confirm cancel
              </Typography>
            </div>
            <Paper
              style={{
                height: "90%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <Button
                onClick={this.closeCancelOrderDialog}
                style={{ width: "75%" }}
              >
                Keep Order
              </Button>
              <Button
                onClick={this.confirmCancelOrder}
                style={{ width: "75%", background: "red" }}
              >
                {this.state.cancellationProgress ? (
                  <CircularProgress size={30} />
                ) : (
                  "Cancel Order"
                )}
              </Button>
            </Paper>
          </div>
        </Dialog>
      </>
    );
  }
}

export default withTheme()(Order);

class OrderItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { item, theme, orderPaid } = this.props;
    return (
      <>
        <ListItem
          className={s.listItem}
          key={item.uuid}
          style={{
            left: this.state.left,
            marginLeft: this.state.left,
          }}
        >
          <ListItemText
            className={s.listItemText}
            primary={
              <span>
                {!item.isSelect ? item.brand : ""} {item.name}
              </span>
            }
            secondary={`${item.sizeDisplay}`}
          />
          <div className={s.quantityPrice}>
            <div> ${(item.basePrice / 100).toFixed(2)}</div>{" "}
            <div style={{ padding: "0 5px 0 5px" }}>x</div>
            <div> {item.quantityInCart ? item.quantityInCart : 0}</div>
          </div>
          <div
            className={
              !item.packed && orderPaid ? s.itemPrice_notPicked : s.itemPrice
            }
            style={{ color: theme.palette.primary.main }}
          >
            $
            {(
              (parseInt(item.quantityInCart ? item.quantityInCart : 0) *
                parseInt(item.basePrice)) /
              100
            ).toFixed(2)}
          </div>
        </ListItem>

        <Divider />
      </>
    );
  }
}
